/* This file is autogenerated, see readme.md for instructions */
import MobileAppInboxSvgIcon from '@bloomreach/banana-theme/icons/mobile-app-inbox.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MobileAppInboxIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MobileAppInboxSvgIcon />
    </Icon>
  );
});

MobileAppInboxIcon.displayName = 'MobileAppInboxIcon';

export default MobileAppInboxIcon;
